import {createHashParamRouter} from '@vkontakte/vk-mini-apps-router';
export const DEFAULT_VIEW = "default_view"
export const HOME_PANEL = "home_panel"
export const GAME_PANEL = "game_panel"
export const RATING_PANEL = "rating_panel"
export const TOURNAMENT_HISTORY_PANEL = "tournament_history_panel"
export const MISSIONS_PANEL = "missions_panel"
export const TOURNAMENTS_PANEL = "tournaments_panel"
export const GAME_RESULTS_MODAL = "game_results_modal";
export const GAME_SUCCESS_FINISH_MODAL = "game_success_finish_modal";
export const GAME_FAILED_FINISH_MODAL = "game_failed_finish_modal";
export const SUBSCRIBE_TOURNAMENT_MODAL = "subscribe_tournament_modal";
export const SUBSCRIBE_MISSIONS_MODAL = "subscribe_missions_modal";
export const TOURNAMENT_GOOD_LUCK_MODAL = "tournament_good_luck_modal";
export const BUY_COINS_MODAL = "buy_coins_modal";

export const router = createHashParamRouter([
    // Страницы
    {
        path: '/',
        panel: HOME_PANEL,
        view: DEFAULT_VIEW,
    },
    {
        path: '/game',
        panel: GAME_PANEL,
        view: DEFAULT_VIEW,
    },
    {
        path: '/rating',
        panel: RATING_PANEL,
        view: DEFAULT_VIEW,
    },
    {
        path: '/tournament-history',
        panel: TOURNAMENT_HISTORY_PANEL,
        view: DEFAULT_VIEW,
    },
    {
        path: '/missions',
        panel: MISSIONS_PANEL,
        view: DEFAULT_VIEW,
    },
    {
        path: '/tournaments',
        panel: TOURNAMENTS_PANEL,
        view: DEFAULT_VIEW,
    },
]);
